$(document).ready(function(){
  $('.itg--testimonial').slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  AOS.init();
  
});

$(window).on('load', function(){
  AOS.refresh();
});